export default __webpack_public_path__ + "static/binance-522a53e08c3716d2d61a8ef1f64bd89d.png";